import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import blackLogo from '../assets/img/black.log.png';
import { clearState, resetPassword } from '../redux/users/slice';
// @ts-ignore
import { Helmet } from 'react-helmet-async';

type FormData = {
  user_pass: string;
  user_pass1: string;
};

const ForgetPasswordConfirm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = new URLSearchParams(useLocation().search);
  const uid = params.get('uid');
  const resetkey = params.get('resetkey');

  const {
    register,
    handleSubmit,
    reset,
  } = useForm<FormData>();
  const [error, setError] = useState<string | null>(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const onSubmit = async (data: FormData) => {
    if (!uid || !resetkey) {
      setError('Reset link is invalid. Please request a new password reset email.');
      setShowAlert(true);
      return;
    }

    if (!data.user_pass || !data.user_pass1) {
      setError('Please enter and confirm your new password.');
      setShowAlert(true);
      return;
    }

    if (data.user_pass !== data.user_pass1) {
      setError('Passwords do not match.');
      setShowAlert(true);
      return;
    }

    setError(null);
    setShowAlert(false);
    setIsSubmitting(true);

    const info = { user_id: uid, resetkey, user_pass: data.user_pass };
    const response = await dispatch<any>(resetPassword(info));
    const payload = response?.payload;
    const resetSucceeded =
      Number(payload?.status) === 200 &&
      payload?.data &&
      typeof payload.data === 'object';

    if (resetSucceeded) {
      dispatch(clearState());
      setIsReset(true);
      reset();
      setIsSubmitting(false);
      return;
    }

    const msg =
      typeof payload?.data === 'string'
        ? payload.data
        : 'Unable to reset password. Please request a new reset email.';
    setError(msg);
    setShowAlert(true);
    setIsSubmitting(false);
  };

  useEffect(() => {
    dispatch(clearState());
    if (!uid || !resetkey) {
      setError('Reset link is invalid. Please request a new password reset email.');
      setShowAlert(true);
    }
  }, [dispatch, uid, resetkey]);

  return (
    <>
      <>

      <Helmet>
          <title> Mousewait Password Reset </title>
          <meta
            name='description'
            content="login in the mouswait for access lounge "
          />
          <meta property='og:title' content='Login - Mousewait' />
          
          <meta
            property='og:image'
            content='https://mousewait.com/static/media/image.png'
          />
          <meta
            property='og:description'
            content='Login in the mousewait'/>
        </Helmet>
        <div className='des-bg'>
          <section className='MW-signpage'>
            <div className='container'>
              <div className='row'>
                {!isReset ? (
                  <div className='Sign-bg'>
                    <div className='Mw-Sign text-center'>
                      <Link to='/disneyland/lounge'>
                        <img
                            src={blackLogo}
                            className='img-fluid'
                            alt='MouseWait-logo'
                        />
                      </Link>
                      
                      <h3>Enter your new password</h3>
                    </div>

                    {error && (
                      <div
                        className={`alert alert-danger ${showAlert ? 'alert-shown' : 'alert-hidden'}`}
                        onTransitionEnd={() => setShowAlert(false)}
                      >
                        {error}
                      </div>
                    )}
                    <form
                      className='space-y-6'
                      onSubmit={handleSubmit(onSubmit)}
                      method='POST'
                    >
                      <div className='sign-from'>
                        <div className='form-floating mb-3'>
                          <input
                            type='password'
                            className='form-control'
                            id='floatingInput'
                            placeholder='Password'
                            {...register('user_pass', { required: true, minLength: 6 })}
                          />
                          <label htmlFor='floatingInput'>
                            <i className='fas fa-user' /> Password
                          </label>
                        </div>
                        <div className='form-floating'>
                          <input
                            type='password'
                            className='form-control'
                            id='floatingPassword'
                            placeholder='Password Confirm'
                            {...register('user_pass1', { required: true, minLength: 6 })}
                          />
                          <label htmlFor='floatingPassword'>
                            <i className='fas fa-lock' /> Password Confirm
                          </label>
                        </div>
                      </div>
                    </form>
                    <div className='sign-btn text-center'>
                      <button
                        type='button'
                        onClick={handleSubmit(onSubmit)}
                        className='MW-btn'
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Resetting...' : 'Reset Password'}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className='Mw-Sign text-center'>
                      <Link to='/disneyland/lounge'>
                        <img
                            src={blackLogo}
                            className='img-fluid'
                            alt='MouseWait-logo'
                        />
                      </Link>
                      
                      <h3>Enter your new password</h3>
                    </div>

                    <p style={{textAlign: 'center', fontSize: '20px'}}>Your password has been reset.</p>
                    
                    <div className='sign-btn text-center'>
                      <button
                        type='button'
                        onClick={() => navigate('/disneyland/login/')}
                        className='MW-btn'
                      >
                        Login
                      </button>
                    </div>
                  </div>
                )}
                <div></div>
              </div>
            </div>
          </section>
        </div>
      </>
    </>
  );
};

export default ForgetPasswordConfirm;
